import { render } from "./RiskOfSerious.vue?vue&type=template&id=4fb615f5&scoped=true"
import script from "./RiskOfSerious.vue?vue&type=script&lang=js"
export * from "./RiskOfSerious.vue?vue&type=script&lang=js"

import "./RiskOfSerious.vue?vue&type=style&index=0&id=4fb615f5&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb615f5"]])

export default __exports__